import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { List } from "lucide-react";
 * // Use <List /> instead
 */
export const ViewListIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M8 5a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H8ZM8 11a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H8ZM7 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  />
);
